/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit File/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ButtonIconLabel from 'DesignSystem/ButtonIconLabel/index'
import DocIcon from 'DesignSystem/Svgs/DocIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function File({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/ViewTraces/Content/AnalysesTree/Analyses/Content/Analysis/Content/Content/File"
  
}) {
let requestFileNameValueData = fromData.useDataFormat({ viewPath,
context: 'request_file',
path: 'name',
format: fromHelpers.formatFilename,
})
let requestFileIdValueData = fromData.useDataValue({ viewPath,
context: 'request_file',
path: 'id',
})
let selectedFileIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'file_id',
})
let aggregateData = fromAggregate.equals(requestFileIdValueData, selectedFileIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ButtonIconLabel
  viewPath={`${viewPath}/ButtonIconLabel`}
 marginTop={4}
 data="request_file.name"
 format="helpers.js formatFilename"
 text={requestFileNameValueData}
 onClick={onClick}
 data="request_file.id"
 data="selected.file_id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 maxWidth={400}
 overflow="hidden"
>
{childProps => (
<DocIcon
{...childProps}
  viewPath={`${viewPath}/DocIcon`}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIconLabel>
{children}
</React.Fragment>)
}